import { Link } from "react-router-dom";
import { useSiteSettings } from "@/lib/useSiteSettings";

export default function HeroSection() {
  const siteConfig = useSiteSettings();
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=beautiful%20rural%20landscape%20Chile%20mountains%20river%20clean%20water%20community%20infrastructure%20water%20tower%20green%20valley%20countryside%20aerial%20view&width=1600&height=900&seq=hero1&orientation=landscape"
          alt="APR Agua Potable Rural"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-sky-900/70 via-sky-900/50 to-sky-900/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-20 flex flex-col items-center text-center">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 border border-white/30 text-white text-sm font-medium mb-8 backdrop-blur-sm">
          <i className="ri-drop-fill text-sky-300"></i>
          {siteConfig.aprFullName}
        </span>

        <h1
          className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-6 max-w-4xl"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          Información y servicios para{" "}
          <span className="text-sky-300">nuestra comunidad</span>
        </h1>

        <p className="text-lg md:text-xl text-white/80 max-w-2xl mb-10 leading-relaxed">
          Consulta noticias, actividades, comunicados y accede al pago de tu cuenta en línea.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/pagar"
            className="flex items-center gap-2 px-8 py-4 rounded-full bg-sky-500 hover:bg-sky-400 text-white font-bold text-base transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg"
          >
            <i className="ri-bank-card-line text-lg"></i>
            Pagar cuenta
          </Link>
          <a
            href={siteConfig.portalUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-8 py-4 rounded-full bg-white/15 hover:bg-white/25 border-2 border-white/50 text-white font-semibold text-base transition-all duration-200 cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            <i className="ri-user-line text-lg"></i>
            Ingresar al portal
          </a>
          <Link
            to="/noticias"
            className="flex items-center gap-2 px-8 py-4 rounded-full bg-emerald-500/80 hover:bg-emerald-500 border-2 border-emerald-400/50 text-white font-semibold text-base transition-all duration-200 cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            <i className="ri-newspaper-line text-lg"></i>
            Ver noticias
          </Link>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap justify-center gap-8 mt-16 pt-10 border-t border-white/20 w-full max-w-2xl">
          {[
            { icon: "ri-home-4-line", value: "+450", label: "Familias conectadas" },
            { icon: "ri-map-pin-line", value: "12 km²", label: "Área de cobertura" },
            { icon: "ri-calendar-line", value: "+20 años", label: "De servicio" },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col items-center gap-1">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 text-sky-300 mb-1">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <span className="text-2xl font-bold text-white">{stat.value}</span>
              <span className="text-white/60 text-sm">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/50 animate-bounce">
        <i className="ri-arrow-down-line text-xl"></i>
      </div>
    </section>
  );
}
